import styled from "styled-components";

export const TempLayerBadgeContainer = styled.div`
  display: flex;
  align-self: baseline;
  padding: 4px 6px;
  align-items: center;
  border-radius: 4px;
  background: ${({ theme }) => theme.palette.element};
  margin-left: 6px;
  margin-right: 0.5rem;
  font-size: 10px;
  font-weight: 600;
`;
